module.exports = __webpack_public_path__ + "static/media/1_Hardly_Noticeable.bad5e29a.svg";